<template>
  <BasicModal
    :title="'ユーザーの復帰'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="set-container">
      <b-table
        class="restore-table disp-scroll"
        :data="deactivated_users">
          <b-table-column field="username" label="名前" v-slot="props">
            <p style="text-align: left;">
              {{props.row.username}}
              <br>
              <span style="font-size: 12px; color: #666;">{{props.row.email}}</span>
            </p>
          </b-table-column>
          <b-table-column field="is_active" label="復帰" centered v-slot="props">
            <button class="button is-small is-danger"  @click="restoreUser(deactivated_users.indexOf(props.row))">復帰</button>
          </b-table-column>
      </b-table>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
    </div>
  </BasicModal>
</template>

<script>
import { mapState }    from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('auth', ['deactivated_users'])
  },
  watch: {
    isShowModal () {
      if (this.isShowModal) this.$store.dispatch('auth/getDeactivatedUsers')
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    async restoreUser (index) {
      if (window.confirm("本当に復帰させますか？")) {
        this.sendControlLog('ユーザー一覧　ユーザー復帰', 'ユーザーの復帰モーダルにて、「復帰」ボタンをクリックした。')
        await this.$store.dispatch('auth/setUsers',{
          'email': this.deactivated_users[index].email,
          'is_active': true
        })
        this.$store.dispatch('auth/getDeactivatedUsers')
        this.$store.dispatch('virtualOffice/sendVirtualOfficeSV', '[REFRESH]')
       }
    }
  }
}
</script>

<style lang="scss" scoped>
.set-container {
  padding: 24px;
  height: 500px;
}
.restore-table {
  width: calc(100%);
  height: calc(100%);
  margin: auto;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/organisms/ModalRestoreUser.vue